import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AuthService } from './auth.service';
import { OAuthModule, OAuthService, OAuthModuleConfig } from 'angular-oauth2-oidc';
import { ConfigService } from '../commons/config/config.service';

const oauthModuleConfigFactory = (config: ConfigService) => ({
  resourceServer: {
    allowedUrls: config.get('auth.protectedResourceMap'),
    sendAccessToken: false
  }
});

@NgModule({
  declarations: [],
  imports: [ CommonModule, OAuthModule.forRoot() ],
  providers: [
    AuthService,
    OAuthService,
    { provide: OAuthModuleConfig, useFactory: oauthModuleConfigFactory, deps: [ ConfigService ] }
  ],
  exports: [ OAuthModule ]
})
export class AuthModule { }
